import React, { useContext, useEffect } from 'react';

import { createStyles, makeStyles } from '@material-ui/core/styles';

import { ModalsContext } from '../../context/ModalsContext';
import { ScriptsContext } from '../../context/ScriptsContext';
import { Modal } from '../Modal';
import { VideoPlayer } from '../VideoPlayer';

const useStyles = makeStyles(() =>
  createStyles({
    videoPlayer: {
      width: '100%',
      height: '100%',
    },
  }),
);

const VideoModal = () => {
  const classes = useStyles();

  const { isVideoModalOpened, videoModalData, setVideoModalStatus } = useContext(ModalsContext);
  const { isLoadedAnalyticScript } = useContext(ScriptsContext);

  const closeModal = () => {
    if (window) {
      window?.verseEvents?.onVideoClose();
    }

    setVideoModalStatus(false);
  };

  useEffect(() => {
    if (
      isLoadedAnalyticScript &&
      videoModalData?.duration &&
      window?.verseEvents?.changeVideoDuration
    ) {
      window.verseEvents.changeVideoDuration(
        videoModalData.duration,
        videoModalData?.title,
        videoModalData?.expertName,
      );
    }
  }, [videoModalData, isLoadedAnalyticScript]);

  return (
    <Modal toggle={closeModal} isOpened={isVideoModalOpened}>
      <VideoPlayer
        className={classes.videoPlayer}
        verseId={videoModalData?.verseId}
        videoUrl={videoModalData?.url}
        bumperVideoUrl={videoModalData?.bumperUrl}
        isModal
      />
    </Modal>
  );
};

export default VideoModal;
